import script from "./rollupComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./rollupComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__